import { render } from "./ContentsPreviewComponent.vue?vue&type=template&id=10718e78&scoped=true&ts=true"
import script from "./ContentsPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./ContentsPreviewComponent.vue?vue&type=script&lang=ts"

import "./ContentsPreviewComponent.vue?vue&type=style&index=0&id=10718e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10718e78"]])

export default __exports__